import React from 'react'
import {ChangeEvent, useRef, useState} from 'react'
import {Button} from '../../../../sharedComponents/components'
import styled from 'styled-components'
import Dropzone from 'react-dropzone-uploader'
import {useTranslation} from 'react-i18next'

interface SiteImportExcelUploaderProps {
  onFileSelected: (file: File) => void
  disabled?: boolean
  onFileRemoved?: () => void
}

const acceptedFileTypes = [
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', //XLSX
  'application/vnd.ms-excel', //XLS
  'application/vnd.oasis.opendocument.spreadsheet' // OpenDocument spreadsheet
]

export const SiteImportExcelUploader = ({onFileSelected, disabled, onFileRemoved}: SiteImportExcelUploaderProps) => {
  const {t} = useTranslation()
  return (
    <DropzoneContainer>
      <Dropzone
        inputContent={t('assets:labels.uploadInstructions', 'Drag or click to upload Excel file')}
        autoUpload={false}
        accept={acceptedFileTypes.join()}
        multiple={false}
        maxFiles={1}
        onChangeStatus={(fileWithMeta, status) => {
          console.log('Status', status)
          if (status === 'done') {
            onFileSelected(fileWithMeta.file)
          }

          if (status === 'removed') {
            onFileRemoved?.()
          }
        }}
      />
    </DropzoneContainer>
  )
}

const DropzoneContainer = styled.div`
  .dzu-dropzone {
    -webkit-overflow-scrolling: touch;
    -ms-overflow-style: none;
    &::-webkit-scrollbar {
      display: none;
      width: 0;
      background: transparent;
    }
  }
`
